var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconFrame = function SvgIconFrame(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;opacity:0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-986 -783.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M184,255H144v40h40Z",
    transform: "translate(842 529)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,263a1,1,0,0,0,0,2h19.585l-2.88,2.91H153a1,1,0,0,0,0,2h14.7l-1.182,1.182H153a1,1,0,0,0,0,2h12.938V286a1,1,0,0,0,2,0V272.5l1.182-1.181V286a1,1,0,0,0,2,0V269.323l2.88-2.91V286a1,1,0,0,0,2,0V264a1,1,0,0,0-1-1Z",
    transform: "translate(842 529)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconFrame, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-frame.a09a8f0e.svg";
export { ForwardRef as ReactComponent };